import type { FetchRequestError } from "@lib/errors";
import { FetchUserEncodedError } from "@lib/errors/FetchUserEncodedError";
import type { SHARED_CONSTANTS_KNOWLEDGE_SOURCE } from "@lib/shared_constants";

import type { KnowledgeSourceDefinitionIdResult } from "../knowledgeSourceDefinitionId";

export type KnowledgeSourceDefinitionResult = KnowledgeSourceDefinitionIdResult;

interface BasePostKnowledgeSourceDefinitionProps {
  appGroupId: string;
  description?: string;
}

export interface PostCatalogKnowledgeSourceDefinitionProps extends BasePostKnowledgeSourceDefinitionProps {
  type: "catalog";
  catalogId: string;
}

export type PostKnowledgeSourceDefinitionProps = PostCatalogKnowledgeSourceDefinitionProps;

export type PostKnowledgeSourceDefinitionNameRequiredError = FetchUserEncodedError<
  SHARED_CONSTANTS_KNOWLEDGE_SOURCE["ERROR_CODES"]["NAME_REQUIRED"]
>;
export type PostKnowledgeSourceDefinitionNameTooLongError = FetchUserEncodedError<
  SHARED_CONSTANTS_KNOWLEDGE_SOURCE["ERROR_CODES"]["NAME_TOO_LONG"],
  { max: number }
>;
export type PostKnowledgeSourceDefinitionDescriptionRequiredError = FetchUserEncodedError<
  SHARED_CONSTANTS_KNOWLEDGE_SOURCE["ERROR_CODES"]["DESCRIPTION_REQUIRED"]
>;
export type PostKnowledgeSourceDefinitionDescriptionTooLongError = FetchUserEncodedError<
  SHARED_CONSTANTS_KNOWLEDGE_SOURCE["ERROR_CODES"]["DESCRIPTION_TOO_LONG"],
  { max: number }
>;
export type PostKnowledgeSourceDefinitionCatalogNotFoundError = FetchUserEncodedError<
  SHARED_CONSTANTS_KNOWLEDGE_SOURCE["ERROR_CODES"]["CATALOG_NOT_FOUND"]
>;
export type PostKnowledgeSourceDefinitionDuplicateCatalogError = FetchUserEncodedError<
  SHARED_CONSTANTS_KNOWLEDGE_SOURCE["ERROR_CODES"]["DUPLICATE_CATALOG"]
>;

export type PostKnowledgeSourceDefinitionErrors =
  | PostKnowledgeSourceDefinitionNameRequiredError
  | PostKnowledgeSourceDefinitionNameTooLongError
  | PostKnowledgeSourceDefinitionDescriptionRequiredError
  | PostKnowledgeSourceDefinitionDescriptionTooLongError
  | PostKnowledgeSourceDefinitionCatalogNotFoundError
  | PostKnowledgeSourceDefinitionDuplicateCatalogError;

export const isPostKnowledgeSourceDefinitionError = (
  error: FetchRequestError
): error is PostKnowledgeSourceDefinitionErrors => {
  return error instanceof FetchUserEncodedError;
};
